var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.334 2.99967H13.6673V4.33301H12.334V12.9997C12.334 13.1765 12.2637 13.3461 12.1387 13.4711C12.0137 13.5961 11.8441 13.6663 11.6673 13.6663H2.33398C2.15717 13.6663 1.9876 13.5961 1.86258 13.4711C1.73756 13.3461 1.66732 13.1765 1.66732 12.9997V4.33301H0.333984V2.99967H3.66732V0.999674C3.66732 0.822863 3.73756 0.653294 3.86258 0.52827C3.9876 0.403246 4.15717 0.333008 4.33398 0.333008H9.66732C9.84413 0.333008 10.0137 0.403246 10.1387 0.52827C10.2637 0.653294 10.334 0.822863 10.334 0.999674V2.99967ZM11.0007 4.33301H3.00065V12.333H11.0007V4.33301ZM5.00065 6.33301H6.33398V10.333H5.00065V6.33301ZM7.66732 6.33301H9.00065V10.333H7.66732V6.33301ZM5.00065 1.66634V2.99967H9.00065V1.66634H5.00065Z",
    fill: "#677684"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.5bc14567.svg";
export { ForwardRef as ReactComponent };